export default "__VITE_ASSET__CDSSUjjP__"